export const HOTEL_PROFILE_CONTENT_REQUEST = "HOTEL_PROFILE_CONTENT_REQUEST"
export const HOTEL_PROFILE_CONTENT_SUCCESS = "HOTEL_PROFILE_CONTENT_SUCCESS"
export const HOTEL_PROFILE_CONTENT_FAILED = "HOTEL_PROFILE_CONTENT_FAILED"


export const HOTEL_PROFILE_CONTENT_UPDATE_BATCH_REQUEST = "HOTEL_PROFILE_CONTENT_UPDATE_BATCH_REQUEST"
export const HOTEL_PROFILE_CONTENT_UPDATE_SUCCESS = "HOTEL_PROFILE_CONTENT_UPDATE_SUCCESS"
export const HOTEL_PROFILE_CONTENT_UPDATE_FAILURE = "HOTEL_PROFILE_CONTENT_UPDATE_FAILURE"

export const HOTEL_PROFILE_GOOGLE_MAP_UPDATE = "HOTEL_PROFILE_GOOGLE_MAP_UPDATE"
export const HOTEL_PROFILE_GOOGLE_MAP_UPDATE_SUCCESS = "HOTEL_PROFILE_GOOGLE_MAP_UPDATE_SUCCESS"
export const HOTEL_PROFILE_GOOGLE_MAP_UPDATE_FAILURE = "HOTEL_PROFILE_GOOGLE_MAP_UPDATE_FAILURE"

export const HOTEL_PROFILE_GALLERY_UPDATE = "HOTEL_PROFILE_GALLERY_UPDATE"
export const HOTEL_PROFILE_GALLERY_UPDATE_SUCCESS = "HOTEL_PROFILE_GALLERY_UPDATE_SUCCESS"
export const HOTEL_PROFILE_GALLERY_UPDATE_FAILURE = "HOTEL_PROFILE_GALLERY_UPDATE_FAILURE"

export const HOTEL_PROFILE_PROCESS_CLEAR = "HOTEL_PROFILE_PROCESS_CLEAR"

export type HotelProfileContentBatchItem = {
  lang: string
  title: string
  description?: string | null
  address?: string | null
  facilities: Array<string>
}


export type HotelProfileContentUpdateBatchPayload = {
  cover_image?: string | null
  contents: HotelProfileContentBatchItem[]
  fax?: string | null
  phones?: string[] | null
  emails?: string[] | null
  website?: string | null
  social_media?: {
    facebook?: string | null
    instagram?: string | null
    line?: string | null
    tiktok?: string | null
  }
}

export type HotelProfileResponse = {
  id: string | null
  code: string | null
  name: string | null
  channel_id?: number | null
  created_at: string | null
  map_url: string | null
  map_iframe: string | null
  map_url_embed: string | null
  logo_url: string | null
  website: string | null
  emails: Array<string>
  phones: Array<string>
  fax: string | null
  social_media: {
    line: string | null
    facebook: string | null
    instagram: string | null
    tiktok?: string | null
  }
  cover_image?: string | null
  contents: HotelProfileContentBatchItem[]
  images: Array<string>
}

export type HotelProfileContentRequest = {
  type: typeof HOTEL_PROFILE_CONTENT_REQUEST
}

export type HotelProfileContentSuccess = {
  type: typeof HOTEL_PROFILE_CONTENT_SUCCESS
  payload: HotelProfileResponse
}

export type HotelProfileContentFailure = {
  type: typeof HOTEL_PROFILE_CONTENT_FAILED
  payload: string
}

export type HotelProfileContentUpdateBatchRequest = {
  type: typeof HOTEL_PROFILE_CONTENT_UPDATE_BATCH_REQUEST
  payload: HotelProfileContentUpdateBatchPayload
}

export type HotelProfileContentUpdateSuccess = {
  type: typeof HOTEL_PROFILE_CONTENT_UPDATE_SUCCESS
}

export type HotelProfileContentUpdateFailure = {
  type: typeof HOTEL_PROFILE_CONTENT_UPDATE_FAILURE
  payload: string
}

export type HotelProfileGoogleMapUpdate = {
  type: typeof HOTEL_PROFILE_GOOGLE_MAP_UPDATE
  payload: any
}

export type HotelProfileGoogleMapUpdateSuccess = {
  type: typeof HOTEL_PROFILE_GOOGLE_MAP_UPDATE_SUCCESS
}

export type HotelProfileGoogleMapUpdateFailure = {
  type: typeof HOTEL_PROFILE_GOOGLE_MAP_UPDATE_FAILURE
  payload: string
}

export type HotelProfileGalleryUpdate = {
  type: typeof HOTEL_PROFILE_GALLERY_UPDATE
  payload: any
}

export type HotelProfileGalleryUpdateSuccess = {
  type: typeof HOTEL_PROFILE_GALLERY_UPDATE_SUCCESS
}

export type HotelProfileGalleryUpdateFailure = {
  type: typeof HOTEL_PROFILE_GALLERY_UPDATE_FAILURE
  payload: string
}

export type HotelProfileProcessClear = {
  type: typeof HOTEL_PROFILE_PROCESS_CLEAR
}

export type HotelProfileConfigAction =
  | HotelProfileContentUpdateBatchRequest
  | HotelProfileContentUpdateSuccess
  | HotelProfileContentUpdateFailure
  | HotelProfileContentRequest
  | HotelProfileContentSuccess
  | HotelProfileContentFailure
  | HotelProfileGoogleMapUpdate
  | HotelProfileGoogleMapUpdateSuccess
  | HotelProfileGoogleMapUpdateFailure
  | HotelProfileGalleryUpdate
  | HotelProfileGalleryUpdateSuccess
  | HotelProfileGalleryUpdateFailure
  | HotelProfileProcessClear
